module.exports = __webpack_public_path__ + "static/media/mst1.d13e6398.png";